import { render, staticRenderFns } from "./payPassword.vue?vue&type=template&id=2225a504&scoped=true"
import script from "./payPassword.vue?vue&type=script&lang=js"
export * from "./payPassword.vue?vue&type=script&lang=js"
import style0 from "./payPassword.vue?vue&type=style&index=0&id=2225a504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225a504",
  null
  
)

export default component.exports